// legacy ajax method for backward-compatibility with jQuery
export default function ajax(url, data, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var requestOptions = {
        method: (_a = options === null || options === void 0 ? void 0 : options.method) !== null && _a !== void 0 ? _a : 'POST',
        credentials: 'same-origin',
    };
    if ((options === null || options === void 0 ? void 0 : options.dataType) === 'json') {
        requestOptions.body = JSON.stringify(data);
        requestOptions.headers = {
            'Content-Type': 'application/json',
        };
    }
    else {
        requestOptions.body = makeFormData(data, options.submitter);
    }
    return fetch(url, requestOptions);
}
export function makeFormData(data, submitter) {
    if (data instanceof FormData) {
        return data;
    }
    if (data instanceof HTMLFormElement) {
        return new FormData(data, submitter);
    }
    var formData = new FormData();
    for (var name in data) {
        if (data.hasOwnProperty(name) && data[name] !== undefined) {
            formData.append(name, data[name]);
        }
    }
    return formData;
}
